import React from "react";
// import "./PrivacyPolicy.css"; // Optional: Create this CSS file to style the policy page

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
    <div className="privacy-policy">
      <h1>TaskBook Security and Privacy Policy</h1>
      <p>Last Updated: October 26, 2024</p>

      <h2>Introduction</h2>
      <p>
        TaskBook (“we”, “our”, or “us”) is committed to protecting the privacy
        and security of our users. This Security and Privacy Policy explains how
        we collect, use, store, and protect your personal information when you
        use the TaskBook app, a mobile task management and collaboration tool.
        By using TaskBook, you agree to the practices described in this Policy.
      </p>

      <h2>Summary of Key Points</h2>
      <ul>
        <li>
          <strong>Data Collection:</strong> We collect basic user information
          necessary to operate the app, including your email, name and FCM token.
        </li>
        <li>
          <strong>Sensitive Data Handling:</strong> Tasks and comments are
          end-to-end encrypted, meaning only you and intended recipients can
          access this data. TaskBook does not have access to the plain text of
          your tasks or comments.
        </li>
        <li>
          <strong>Data Security:</strong> We implement industry-standard
          encryption and secure storage practices for all user data.
        </li>
        <li>
          <strong>User Rights:</strong> We comply with GDPR and CCPA, providing
          users the rights to access, update, delete, or export their data.
        </li>
        <li>
          <strong>Push Notifications:</strong> We use FCM tokens to deliver push
          notifications to users. This token is stored securely and used solely
          for delivering notifications.
        </li>
      </ul>

      <h2>1. Information We Collect</h2>
      <p>
        TaskBook collects limited personal information from users to operate,
        secure, and improve our services. The data we collect includes:
      </p>
      <ul>
        <li>
          <strong>Email Address:</strong> Used for account registration,
          authentication, and password recovery.
        </li>
        <li>
          <strong>Name:</strong> Displayed in the app to personalize your
          profile and identify you to collaborators.
        </li>
        <li>
          <strong>FCM Token:</strong> Collected to deliver push notifications to
          your device. This token is unique to each device and is stored
          securely on our servers.
        </li>
        <li>
          <strong>Joined Date and Online Status:</strong> Used to display your
          activity within the app.
        </li>
      </ul>

      <h3>Sensitive Data</h3>
      <p>
        <strong>Tasks and Comments:</strong> All tasks and comments are
        end-to-end encrypted. Only you and authorized recipients can decrypt and
        access this data. TaskBook does not have the ability to view your tasks
        or comments in plain text.
      </p>

      <h2>2. Data Encryption and Security</h2>
      <p><strong>Encryption:</strong></p>
      <ul>
        <li>
          <strong>End-to-End Encryption:</strong> Tasks and comments are
          encrypted end-to-end, ensuring that only you and intended recipients
          have access to the content. TaskBook cannot view or decrypt this data.
        </li>
        <li>
          <strong>Data in Transit:</strong> We use HTTPS and TLS to encrypt data
          transmitted between your device and our servers, ensuring that no
          third party can intercept this data.
        </li>
        <li>
          <strong>Data at Rest:</strong> Personal information stored in our
          database, such as your profile image URL and email address, is
          encrypted at rest to prevent unauthorized access.
        </li>
      </ul>

      <h2>3. How We Use Your Information</h2>
      <p>
        We use your personal information to provide, maintain, and improve
        TaskBook’s services. Specifically, we use your data in the following
        ways:
      </p>
      <ul>
        <li>Account Creation and Management: To create and manage your account, authenticate your identity, and provide you with access to the app.</li>
        <li>Push Notifications: To send important updates and reminders related to your tasks.</li>
        <li>App Personalization: To display your name and profile image within the app.</li>
        <li>Internal Analytics and Reporting: To improve our features and performance.</li>
      </ul>

      <h2>4. Sharing and Disclosure of Information</h2>
      <p>We do not sell, rent, or share your personal information with third parties except as necessary to operate the TaskBook app or comply with legal obligations.</p>

      <h2>5. Data Retention and Deletion</h2>
      <p>We retain your data only as long as necessary to provide services or resolve disputes.</p>

      <h2>6. User Rights (GDPR and CCPA Compliance)</h2>
      <p>Depending on your location, you may have specific rights under applicable laws. Please contact us to exercise these rights.</p>

      <h2>7. Push Notification Permissions</h2>
      <p>You can disable push notifications at any time by adjusting your device’s notification settings.</p>

      <h2>8. Children’s Privacy</h2>
      <p>TaskBook is not intended for users under the age of 16.</p>

      <h2>9. Security Measures</h2>
      <p>We implement regular security reviews and encryption practices to protect your data.</p>

      <h2>10. Data Breach Notification</h2>
      <p>We will notify affected users and authorities as required by law in the event of a data breach.</p>

      <h2>11. Changes to This Policy</h2>
      <p>We may update this policy periodically. The latest version will always be available on our website.</p>

      <h2>12. Contact Us</h2>
      <p>If you have any questions, contact us at:</p>
      <address>
        Email: <a href="mailto:contact@xoxgroup.dev">contact@xoxgroup.dev</a> <br />
       
      </address>
    </div>
    </div>
  );
};

export default PrivacyPolicy;
